{
  "pageTitle": "Skupljanje podataka",
  "startScraping": "Pokreni skupljanje",
  "scrapingInProgress": "Skupljanje u toku...",
  "clearLogs": "Obriši dnevnik",
  "back": "Nazad",
  "waitingForLogs": "Čekam logove...",
  "title": "Logovi uživo",
  "start": "Pokreni",
  "pending": "U toku",
  "finished": "Završeno",
  "failed": "Neuspjelo",
  "loading": "Učitavanje...",
  "warning": "Upozorenje"
}
